import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-zinc-950" data-id="element-120" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-121" data-mp="223ekniyd552e">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-black border-2 border-amber-400/80 rounded-3xl p-8 md:p-12 text-center" data-id="element-122" data-mp="222d797tvk6hi">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-amber-400/10 text-amber-400 mb-8 border-2 border-amber-400/60" data-id="element-123" data-mp="14hh965iehzzy">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-124" data-mp="1edk8z4ps5mjq" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-6 text-white" data-id="element-125" data-mp="qo9h6cqer2hq">
            7-Day Refund Policy
          </h2>
          <div className="space-y-6 text-lg text-zinc-400 max-w-2xl mx-auto" data-id="element-126" data-mp="lo4zwkhoe3qg">
            <p className="text-zinc-300" data-id="element-127" data-mp="p01h478gp19q">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-zinc-200" data-id="element-128" data-mp="ty2zepy2cwk5">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and we will review the case according to our refund policy.
            </p>
            <p className="text-sm text-zinc-500 mt-8" data-id="element-129" data-mp="628dt3txepbt">
              The product is delivered digitally in PDF format.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}